const Header = {
  el: {
    header: document.querySelector('.header'),
    headerNav: document.querySelector('.header__nav'),
    menuButton: document.querySelector('.header__menubutton'),
    closeButton: document.querySelector('.header__menuclose'),
  },

  isAnimating: false,

  hideOnClickOutside(element) {
    const outsideClickListener = (event) => {
      if (!element.contains(event.target) && !this.isAnimating) {
        // or use: event.target.closest(selector) === null
        this.closeNav()
        removeClickListener()
      }
    }

    const removeClickListener = () => {
      document.removeEventListener('click', outsideClickListener)
    }

    document.addEventListener('click', outsideClickListener)
  },

  init() {
    if (!this.el.menuButton) {
      return
    }

    this.el.menuButton.addEventListener('click', () => {
      if (!this.isAnimating) {
        this.el.headerNav.classList.remove('hidden')
        this.el.header.classList.add('pointer-events-none')
        this.isAnimating = true

        setTimeout(() => {
          this.el.header.classList.add('header--open')
          this.el.menuButton.classList.add('hidden')
          this.el.closeButton.classList.remove('hidden')
        }, 0)

        setTimeout(() => {
          this.hideOnClickOutside(this.el.header)
          this.el.header.classList.remove('pointer-events-none')
          this.isAnimating = false
        }, 600)
      }
    })

    this.el.closeButton.addEventListener('click', () => {
      if (!this.isAnimating) {
        this.closeNav()
      }
    })
  },

  closeNav() {
    this.el.header.classList.remove('header--open')
    this.el.closeButton.classList.add('hidden')
    this.el.menuButton.classList.remove('hidden')
    this.el.headerNav.classList.add('hidden')
  },
}

export default Header
